import React from "react";
import { GooglePlayIcon } from "@picklebet/ui";
import { AppStoreIcon } from "@picklebet/ui";
import { ReactComponent as QRCode } from "./assets/qrcode.svg";

import * as styles from "./Footer.module.scss";

const DownloadApp = () => {
  return (
    <div className={styles.download}>
      <div className={styles.qr}>
        <QRCode />
      </div>
      <div className={styles.buttons}>
        <a
          href={`https://play.google.com/store/apps/details?id=com.picklebet`}
          className={styles.button}
        >
          <GooglePlayIcon className={styles.storeIcon} />
          <span className={styles.buttonTextAndLabel}>
            <span className={styles.label}>Get it On</span>
            <span className={styles.brand}>Google Play</span>
          </span>
        </a>

        <a
          href={`https://apps.apple.com/au/app/picklebet-esports-betting-app/id1529988128`}
          className={styles.button}
        >
          <AppStoreIcon className={styles.storeIcon} />
          <span className={styles.buttonTextAndLabel}>
            <span className={styles.label}>Download on the</span>
            <span className={styles.brand}>App Store</span>
          </span>
        </a>
      </div>
    </div>
  );
};

export { DownloadApp };
